import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first, map } from 'rxjs/operators';

import { AlertService, ExamService } from '../_services';
import { Globals } from '../_helpers';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import * as RecordRTC from 'recordrtc';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpHeaders, HttpClient } from '@angular/common/http';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'assessor-test-viva',
    templateUrl: './viva-page.component.html',
    styleUrls: ['./test-viva-page.component.css']
})

export class VivaComponent implements AfterViewInit, OnInit {
    @ViewChild('video') video;
    @ViewChild('audio') audio;

    @ViewChild('rerecordVideoSwal') private rerecordVideoSwal: SwalComponent;
    @ViewChild('rerecordAudioSwal') private rerecordAudioSwal: SwalComponent;
    @ViewChild('stoprecordingSwal') private stoprecordingSwal: SwalComponent;
    @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
    @ViewChild('exitexamSwal') private exitexamSwal: SwalComponent;
    @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    matcher = new MyErrorStateMatcher();

    @HostListener('window:keyup', ['$event'])
    onKeyupHandler(event: KeyboardEvent) {
        if (event.keyCode == 123 || event.keyCode == 122)
            //this.autoSubmitAnswers();
            //console.log(event.keyCode);
            event.stopPropagation();
    }


    // @HostListener('document:keyup', ['$event'])
    // onKeyUp(event: KeyboardEvent) {
    //     if (event.keyCode == 44 || event.keyCode == 123 ) {
    //         event.preventDefault()
    //     }
    // }

    studentName: string = '';
    studentCode: string = '';
    answerdObj = {};
    notSubmitObj = [];
    questArr = [];
    loading = false;
    indexClasses: string;
    timershow: string;
    returnUrl: string;
    maxMarks: number;
    duration: number = 0;
    type: string;
    totalQuestion: number;
    question: string;
    questionInst: string;
    index: number = 1;
    answer_id: number;
    answer_type: string;
    deficulty_lebel: number = 0;
    userData = {};
    settings = {};
    distance: any;
    totalAnswered: number = 0;
    totalSubmited: number = 0;
    totalVisited: number = 0;
    totalNotAnswered: number = 0;
    interval;
    settime;
    isPause = false;
    visitedQuesObj = {};
    isSubmit = false;
    isPauseBtn = false;
    isRerecord = false;
    speechLang: string = 'en-GB';
    instructions = [];

    isMedia = false;
    qaudioUrl: string = '';
    qvideoUrl: string = '';
    qimageUrl: string = '';
    isDone = false;
    currentIndex = 0;
    prevques = [];
    question_id: number = 0;
    ssclogo: string = '';
    nos: string = '';
    apiinterval;
    freezestatus: number = 0;
    isTextConversion = false;
    /* Chart Variable */
    //public pieChartLabels: string[] = ['Answered', 'Submitted', 'Visitted', 'Not attempted'];
    public pieChartLabels: string[] = ['Attempted', 'Not Attempted'];
    public pieChartData: number[] = [];
    public pieChartType: string = 'pie';
    public pieChartLegend = false;
    public chartColors: any[] = [{
        //backgroundColor: ["#44e51e", "#FF7272", "#ce03dc", "#c4c4c4"]
        backgroundColor: ["#2B8B14", "#c4c4c4"]
    }];

    public recordTimer: string;
    public recording = false;
    public isVideo = true;
    public isAudio = true;
    public videoRecording = false;
    public audioRecording = false;
    public videoUrl;
    public audioUrl;

    private stream: MediaStream;
    private recordRTC: any;

    binaryData = [];
    base64Data;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private examService: ExamService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private domSanitizer: DomSanitizer,
        private http: HttpClient        
    ) { }

    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        /*        if(step != this.globals.complSteps['viva-test'])
                    this.router.navigateByUrl('/login');*/

        //this.requestFullscreen(document.documentElement);

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        this.studentName = this.userData['name'];
        this.studentCode = this.userData['code'];
        if (this.settings['submit'] == 0)
            this.isSubmit = true;
        if (this.settings['student_pause'] == 0) {
            this.isPauseBtn = true;
        }
        if (this.settings['exam_logo'] != "") {
            this.ssclogo = this.settings['exam_logo'];
        }
        if (this.settings['text_conversion'] == 1) {
          this.isTextConversion = true;
        }
        /* call function for first question and exam info */
        this.getVivaExams();
     
        this.apiinterval = setInterval(() => {
            this.vivaStausFreeze(); 
        }, 15000);
         if(this.isTextConversion == true)
        {
         this.getSecondaryLang();     
        }        
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
    }
    secondaryLang:string = '';
    primarylang;
    seclang_code: string = '';
    selected:string;
    currentlanguage: string;
    secondaryLanguage(value) {
    this.secondaryLang = value;
    this.seclang_code = this.secondaryLang.split("-")[0];
    if(this.currentlanguage != this.seclang_code)
    {   
      this.currentlanguage = this.seclang_code;
      this.googleAPI(this.primary_lang_code, this.seclang_code);
    }
    }  
    primaryLanguage() {
    if(this.currentlanguage != this.primary_lang_code)
    {
      this.currentlanguage = this.primary_lang_code;
      this.googleAPI(this.seclang_code,this.primary_lang_code);
    }
    this.selected = 'Select a language';
    }   
    googleAPI(primary_lang, secondary_land)
    {
    this.loading = true;
    this.spinner.show();
    var quest = this.question;
    const body = { q: quest, source: primary_lang, target:secondary_land };
    this.http.post<any>("https://translation.googleapis.com/language/translate/v2?key=AIzaSyBobH9FTqp_npqwcgDlwjeKAZse_v_yp6Q", body).subscribe((res: any) => {
        var translateRes = res;
        var getResponse = translateRes.data.translations;
        for (var g = 0; g < getResponse.length; g++) 
        {
          this.question = getResponse[g].translatedText;
          this.loading = false;
          this.spinner.hide();         
        }
    });
    }
    ngAfterViewInit() {
        // set the initial state of the video
        let video: HTMLVideoElement = this.video.nativeElement;
        video.muted = false;
        video.controls = true;
        video.autoplay = false;

        let audio: HTMLAudioElement = this.audio.nativeElement;
        audio.controls = true;
        audio.muted = false;
        this.base64Data = document.getElementById('base64Field');
    }

    toggleControls(media) {
        if (media == 'video') {
            let video: HTMLVideoElement = this.video.nativeElement;
            video.muted = !video.muted;
            video.controls = !video.controls;
            video.autoplay = !video.autoplay;
        }
        /*else{
            let audio:HTMLAudioElement = this.audio.nativeElement;
            audio.controls = true;
        }*/
    }

    successVideoCallback(stream: MediaStream) {
        var options = {
            mimeType: 'video/webm;codecs=vp9', // or video/webm\;codecs=h264 or video/webm\;codecs=vp9
            audioBitsPerSecond: 568000,
            videoBitsPerSecond: 568000,
            bitsPerSecond: 568000,
            checkForInactiveTracks: true,
            ignoreMutedMedia: true,
            numberOfAudioChannels: 1
        };
        this.recordRTC = RecordRTC(stream, options);
        this.recordRTC.startRecording();
        let video: HTMLVideoElement = this.video.nativeElement;
        this.binaryData.push(stream);
        video.src = window.URL.createObjectURL(new Blob(this.binaryData));
        this.stream = stream;
        this.toggleControls('video');
    }

    successAudioCallback(stream: MediaStream) {
        var options = {
            mimeType: 'audio/wav',
        };
        this.recordRTC = RecordRTC(stream, options);
        this.recordRTC.startRecording();
        let audio: HTMLAudioElement = this.audio.nativeElement;
        this.binaryData.push(stream);
        audio.src = window.URL.createObjectURL(new Blob(this.binaryData));
        this.stream = stream;
        this.toggleControls('audio');
    }

    errorCallback() {
        //handle error here
    }

    processVideo(audioVideoWebMURL) {
        let video: HTMLVideoElement = this.video.nativeElement;
        let recordRTC = this.recordRTC;
        video.src = audioVideoWebMURL;
        this.toggleControls('video');
        var videoBolb = recordRTC.getBlob();
        recordRTC.getDataURL(function (dataURL) {
            let base64Field = document.getElementById('base64Field');
            base64Field['value'] = dataURL;
        });
        //this.download('video');
    }

    processAudio(audioWebMURL) {
        let audio: HTMLAudioElement = this.audio.nativeElement;
        let recordRTC = this.recordRTC;
        audio.src = audioWebMURL;
        this.toggleControls('audio');
        var audioBlob = recordRTC.getBlob();
        recordRTC.getDataURL(function (dataURL) {
            let base64Field = document.getElementById('base64Field');
            base64Field['value'] = dataURL;
        });
        //this.download('audio');
    }
    startVideoRec() {
        this.binaryData = [];
        if (!this.isRerecord && this.base64Data.value != '') {
            this.rerecordVideoSwal.show();
        }
        else {
            this.resetRec();
            this.recording = true;
            this.isRerecord = false;
            this.answer_type = 'video';
            let mediaConstraints = {
                video: true,
                audio: true
            };
            navigator.mediaDevices.getUserMedia(mediaConstraints).then(this.successVideoCallback.bind(this), this.errorCallback.bind(this));
            this.videoRecording = true;
            this.recorderTimer('start');
        }
    }

    startAudioRec() {
        this.binaryData = [];
        if (!this.isRerecord && this.base64Data.value != '') {
            this.rerecordAudioSwal.show();
        }
        else {

            this.resetRec();
            this.recording = true;
            this.isRerecord = false;
            this.answer_type = 'audio';
            let mediaConstraints = {
                video: false,
                audio: true
            };
            navigator.mediaDevices.getUserMedia(mediaConstraints).then(this.successAudioCallback.bind(this), this.errorCallback.bind(this));
            this.recorderTimer('start');
        }
    }

    stopRecording() {
        let recordRTC = this.recordRTC;
        if (this.videoRecording) {
            recordRTC.stopRecording(this.processVideo.bind(this));
        }
        else {
            recordRTC.stopRecording(this.processAudio.bind(this));
            this.audioRecording = true;
        }

        let stream = this.stream;
        stream.getAudioTracks().forEach(track => track.stop());
        stream.getVideoTracks().forEach(track => track.stop());
        this.recorderTimer('stop');
        this.recording = false;
    }

    download(media) {
        if (media == 'video') {
            this.recordRTC.save('video.webm');
        }
        else {
            this.recordRTC.save('audio.wav');
        }
    }

    /* Re record confirmation for audio*/
    public reRecordAudio() {
        this.isRerecord = true;
        this.startAudioRec();
    }

    /* Re record confirmation for audio*/
    public reRecordVideo() {
        this.isRerecord = true;
        this.startVideoRec();
    }

    /* Start and stop recorder timer */
    private recorderTimer(action) {
        if (action == 'stop') {
            var minutes = 0;
            var seconds = 0;
            clearInterval(this.interval);
            this.recordTimer = '';
            return;
        }
        else {
            var minutes = 6;
            var seconds = 0;
        }

        this.interval = setInterval(() => {
            --seconds;
            minutes = (seconds < 0) ? --minutes : minutes;

            seconds = (seconds < 0) ? 59 : seconds;

            if (minutes <= 0 && seconds <= 0) {
                clearInterval(this.interval);
                this.stopRecording();
            }
            this.recordTimer = minutes + ':' + seconds;

        }, 1000);
    }

    /* Get Exam data when exam UI is load */
    private getVivaExams() {
        this.loading = true;
        this.spinner.show();
        this.questArr = [];
        this.answerdObj = {};
        this.isMedia = false;
        this.qaudioUrl = '';
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.examService.getVivaFirstQuestion(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 'web', this.settings['shuffle_ans'], this.settings['shuffle_ques'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.resetRec();
                        let exam = data.exams;
                        this.duration = exam.duration;
                        this.type = exam.type;
                        this.totalQuestion = exam.totalq;
                        let questionData = exam.question; //console.log(questionData);
                        this.prevques = exam.res;
                        this.speechLang = questionData.lang;
                        this.answer_id = 0;
                        this.question = questionData.question;
                        if(this.isTextConversion == true)
                        {
                          if(this.currentlanguage != this.primary_lang_code)
                          {
                            this.googleAPI(this.primary_lang_code, this.seclang_code);
                          }               
                        }                         
                        this.question_id = questionData.question_id;
                        this.questionInst = questionData.question_inst;
                        this.maxMarks = questionData.max_marks;
                        this.nos = questionData.nos;

                        if (questionData.media != '') {
                            this.isMedia = false; //true
                            if (questionData.media_type == 2) {
                                this.qimageUrl = questionData.media;
                            }
                            else if (questionData.media_type == 3) {
                                this.qaudioUrl = questionData.media;
                            }
                            else if (questionData.media_type == 4) {
                                this.qvideoUrl = questionData.media;
                            }
                        }

                        /* Create array for question index */
                        this.createArrayQuesNoObj(this.totalQuestion, this.prevques);

                        /* Set counter */
                        //this.counter(exam.duration);

                        /* set button background color */
                        this.btnStyle(1, 'current');
                        this.visitedQuesObj[1] = 'visited';

                        let inst = (data.instruction).split('\n');
                        for (var i = 0; i < inst.length; ++i) {
                            let html = inst[i];
                            if (html != '')
                                this.instructions[i] = { index: i + 1, text: html };
                        }

                        this.spinner.hide();

                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }

    /* Get Exam data by index number */
    private getVivaQuestionByIndex() {
        this.loading = true;
        this.isMedia = false;
        this.qaudioUrl = '';
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.spinner.show();
        this.examService.getVivaQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.deficulty_lebel, 'web')
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.resetRec();
                        let questionData = data.question;
                        this.speechLang = questionData.lang;
                        this.question = questionData.question;
                        if(this.isTextConversion == true)
                        {
                          if(this.currentlanguage != this.primary_lang_code)
                          {
                            this.googleAPI(this.primary_lang_code, this.seclang_code);
                          }               
                        }                         
                        this.question_id = questionData.question_id;
                        this.questionInst = questionData.question_inst;
                        this.maxMarks = questionData.max_marks;
                        this.nos = questionData.nos;
                        /*if(questionData.answer_audio != '')
                            this.url = questionData.answer_audio_url;
                        else if(questionData.answer_video != '')
                            this.url = questionData.answer_video_url;*/

                        if (questionData.media != '') {
                            this.isMedia = true;
                            if (questionData.media_type == 2) {
                                this.qimageUrl = questionData.media;
                            }
                            else if (questionData.media_type == 3) {
                                this.qaudioUrl = questionData.media;
                            }
                            else if (questionData.media_type == 4) {
                                this.qvideoUrl = questionData.media;
                            }
                        }
                    }
                    else {
                        this.loading = false;
                        //this.router.navigateByUrl('/login');

                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }

    /* Save current and get next */
    private saveAndNext(action) {
        if (typeof this.base64Data.value != 'undefined' && this.base64Data.value != '') {
            let audio: HTMLAudioElement = this.audio.nativeElement;
            let video: HTMLAudioElement = this.video.nativeElement;        
            audio.pause();
            video.pause();         
            this.submitSingleVivaQuestion(this.index, this.question_id);            
        }

        if (action == 'next') {
            let curind = this.getNextIndex('next', this.index + 1);
            this.index = curind;
        }
        else if (action == 'prev') {
            let curind = this.getNextIndex('prev', this.index - 1);
            this.index = curind;
        }

        this.getVivaQuestionByIndex();
    }

    /* On index click get this question */
    public getQuestionIndex(event, item) {
        if (this.recording) {
            this.stoprecordingSwal.show();
        }
        else if (!this.isPause && this.visitedQuesObj[item] != 'submited') {
            speechSynthesis.cancel();
            this.index = item;
            this.saveAndNext('current');
            this.visitedQuesObj[this.index] = 'visited';
        }
    }

    /* On click previous button get question */
    public prevQuestion() {
        if (this.recording) {
            this.stoprecordingSwal.show();
        }
        else if (this.index > 1 && !this.isPause) {
            speechSynthesis.cancel();
            //console.log(Object.keys(this.visitedQuesObj).length); 
            //console.log(this.index);
            /*            for (var i = this.index; i > 0; i--) {
                            if(this.visitedQuesObj[i] != 'submited' && this.visitedQuesObj[i] != 'undefined')
                            {
                               this.index = i;
                               break;               
                            }
            
                        } */
            this.saveAndNext('prev');
            this.visitedQuesObj[this.index] = 'visited';
        }
        //console.log('Prev Click: ');        
        //console.log(this.visitedQuesObj);          
    }

    /* On click next button get question */
    public nextQuestion() {
        if (this.recording) {
            this.stoprecordingSwal.show();
        }
        else if (this.index < this.totalQuestion && !this.isPause) {
            speechSynthesis.cancel();
            //console.log(Object.keys(this.visitedQuesObj).length); 
            //console.log(this.index);
            /*            for (var i = this.index; i < Object.keys(this.visitedQuesObj).length; i++) {
                            if(this.visitedQuesObj[i] != 'submited' && this.visitedQuesObj[i] != 'undefined')
                            {
                               this.index = i;
                               break;               
                            }
            
                        } */
            this.saveAndNext('next');
            this.visitedQuesObj[this.index] = 'visited';
        }
        else if (!this.recording && !this.isPause) {
            this.submitSingleVivaQuestion(this.index, this.question_id);
            /*if(typeof this.base64Data.value != 'undefined' && this.base64Data.value != ''){
                this.submitSingleVivaQuestion(this.index);
            }*/
        }
        //console.log('Next Click: ');        
        //console.log(this.visitedQuesObj);        
    }

    /* On click pouse button stop timer */
    public pauseExam() {
        if (this.settings['student_pause'] == 1) {
            let status = '';
            if (this.isPause) {
                this.isPause = false;
                status = 'resume';
                document.getElementById("pauseBtn").innerHTML = '<i class="fa fa-pause-circle-o"></i> Pause';
            }
            else {
                this.isPause = true;
                status = 'pause';
                document.getElementById("pauseBtn").innerHTML = '<i class="fa fa-play-circle-o"></i> Resume';
            }
            this.spinner.show();
            this.examService.setExamPauseResume(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], status, 0,0)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {

                        }
                        else {
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                        //this.router.navigateByUrl('/login');
                    }
                );
        }
    }

    /* submit single question */
    public submitSingleVivaQuestion(index, question_id) {
        this.loading = true;
        //console.log(this.base64Data.value.length);       
        if (this.base64Data.value.length > 100) {
            this.examService.setVivaQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], index, 'web', this.answer_type, this.base64Data.value, question_id)
                .pipe(first())
                .subscribe(
                    data => {
                        this.spinner.show();
                        if (index == this.totalQuestion) {
                            //this.isDone = true;
                            this.base64Data.value = '';
                            this.btnStyle(index, 'submited');
                            this.visitedQuesObj[index] = 'submited';
                            this.openSubmitArea();
                            //this.router.navigateByUrl('/login');
                        }
                        else if (data.code == 1000) {
                            this.base64Data.value = '';
                            this.btnStyle(index, 'submited');
                            this.visitedQuesObj[index] = 'submited';
                        }
                        else {
                            this.base64Data.value = '';
                            this.loading = false;
                            //this.router.navigateByUrl('/login');
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                        //this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }
                );
        }
        else {
            if (index == this.totalQuestion) {
                this.visitedQuesObj[this.index] = 'visited';
                this.openSubmitArea();
                //this.router.navigateByUrl('/login');
            }
            else {
                this.btnStyle(index, 'submited');
                this.visitedQuesObj[index] = 'visited';
                this.spinner.hide();
            }
        }
    }

    /* Change button color according to action */
    private btnStyle(btnIndex, status) {
        setTimeout(function () {
            var currentBtn = document.getElementById('btn-' + btnIndex);
            if (typeof currentBtn != 'undefined') {
                if (status == 'answered') {
                    currentBtn.classList.add('btn-answered');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if (status == 'submited') {
                    currentBtn.classList.add('btn-submited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if (status == 'visited') {
                    currentBtn.classList.add('btn-visited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if (status == 'current') {
                    var preBtn = document.getElementsByClassName('visited-btn');
                    if (typeof preBtn != 'undefined' && preBtn.length > 0) {
                        for (var i = 0; i < preBtn.length; ++i) {
                            preBtn[i].classList.add('btn-visited');
                            preBtn[i].classList.remove('btn-current');
                            preBtn[i].classList.remove('btn-answered');
                            preBtn[i].classList.remove('btn-notvisited');
                            preBtn[i].classList.remove('visited-btn');
                        }
                    }

                    currentBtn.classList.add('visited-btn');
                    currentBtn.classList.add('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if (status == 'not-answered') {
                    currentBtn.classList.add('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                }
            }
        }, 200);
    }

    /* Create timer according to duration */
    /*private counter(duration){
        var minutes = parseInt(duration);
        var seconds = 0;

        this.interval = setInterval(() => {

           if(!this.isPause){
                --seconds;
                minutes = (seconds < 0) ? --minutes : minutes;
                  
                seconds = (seconds < 0) ? 59 : seconds;

                if(minutes == 5 && seconds == 0){
                   document.getElementById('timer-id').classList.add('blink_me'); 
                }

                if(minutes <= 0 && seconds <= 0){
                    clearInterval(this.interval);
                    this.timeoverSwal.show();
                    this.settime = setTimeout(function(){
                        this.timeoverSwal.hide();
                        this.submitFinalExam();
                    }, 200);
                }

                this.timershow = minutes+':'+seconds;
            }
        },1000);
    }*/

    /* Check Submitted question and jump to next */
    private getNextIndex(type, index) {
        let questDb = this.visitedQuesObj;
        //console.log('array length '+Object.keys(questDb).length);
        if (Object.keys(questDb).length < 1) {
            return index;
        }
        else if (type == 'next') {
            for (var i = index; i < this.totalQuestion; ++i) {
                if (questDb[i] != 'submited')
                    return i;
            }
            return index;
        }
        else if (type == 'prev') {
            for (var i = index; i > 0; --i) {
                if (questDb[i] != 'submited')
                    return i;
            }
            return index + 1;
        }
    }

    /* Create array of object for number of question and lebel */
    private createArrayQuesNoObj(totalQuest, preques) {
        // for (var i = 0; i < totalQuest; ++i) {
        // 	this.questArr[i] = {index: i+1};
        // }
        for (var i = 0; i < totalQuest; ++i) {
            this.questArr[i] = { index: i + 1 };

            for (var j = 0; j < preques.length; j++) {
                var setColor = false;
                if (preques[j].index === (i + 1)) {
                    var answer = preques[j].answer ? 1 : 0;
                    if (answer == 1 && setColor == false) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                    }
                    if (answer == 0 && setColor == false) {
                        this.btnStyle(preques[j].index, 'visited');
                        this.visitedQuesObj[preques[j].index] = 'visited';
                        setColor = true;
                    }
                }
            }
        }
    }

    /* Go to full screen */
    public requestFullscreen(ele) {
        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else {
            console.log('Fullscreen API is not supported.');
        }
    };



    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }



    @HostListener('contextmenu', ['$event'])
    onRightClick(event) {
        event.preventDefault();
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {

        console.log(event);
        event.returnValue = false;
        event.preventDefault();


    }
    @HostListener('document:keyup', ['$event'])
    handleKeyEvent(event: KeyboardEvent) {

        console.log(event);
        event.returnValue = false;
        event.preventDefault();
    }

    @HostListener('document:keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {
        if (event.keyCode == 44 || event.keyCode == 123 ) {
            event.preventDefault()
        }
    }

   
    //myTimeout;
    /* Text to speech */
    public textToSpeech() {
        var navUserAgent = navigator.userAgent;
        speechSynthesis.cancel();
        var myTimeout = setTimeout(function () {
            speechSynthesis.pause();
            speechSynthesis.resume();
        }, 15000);         
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices(); //console.log(voices);
        for(var i = 0; i < voices.length ; i++) {
            if(voices[i].lang == 'hi-IN')
            {
                msg.voice = voices[i];
            }
        }
/*        if(navUserAgent.indexOf("Opera") > -1) 
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Chrome") > -1)
        {
           msg.voice = voices[12];
        }else if(navUserAgent.indexOf("MSIE") > -1 || navUserAgent.indexOf("rv:") > -1)
        {
             msg.voice = voices[40];
        }else if(navUserAgent.indexOf("Firefox") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("Safari") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("OP") > -1)
        {
             //msg.voice = voices[7];
        }  
        else if(navUserAgent.indexOf("Edg") > -1)
        {
             msg.voice = voices[40];
        }*/         
        msg.volume = 1; // 0 to 1
        msg.rate = 1; // 0.1 to 10
        msg.pitch = 0; //0 to 2
        msg.text = this.question;
        msg.lang = this.speechLang; //hi-IN hindi india, en-GB great briten
        speechSynthesis.speak(msg);              
        msg.onend = function(e) {
          speechSynthesis.cancel();
          clearTimeout(myTimeout);
        }; 
    }

    /* Reset recordind data */
    private resetRec() {         
        this.audioRecording = false;
        this.videoRecording = false;
        this.base64Data.value = '';
    }

    /* Confirm Exit exam */
    public conFirmExitExam() {
        this.exitexamSwal.show();
    }
    public submitAutoExam() {
        this.router.navigateByUrl('/login');
    }
    /* Pie chart */
    public openSubmitArea() {
        if (!this.isPause) {
            let visitedq = 0;
            let submitedq = 0;
            let answerdq = 0;
            let notAttemptq = 0;
            if (Object.keys(this.visitedQuesObj).length > 0) {
                for (let ansobj in this.visitedQuesObj) {
                    if (this.visitedQuesObj[ansobj] == 'submited')
                        submitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'visited')
                        visitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'answered')
                        answerdq++;
                }

                notAttemptq = this.totalQuestion - (submitedq + visitedq + answerdq);
            }
            else {
                notAttemptq = this.totalQuestion;
            }

/*            this.pieChartData = [answerdq, submitedq, visitedq, notAttemptq];
            this.totalAnswered = answerdq;
            this.totalSubmited = submitedq;
            this.totalVisited = visitedq;
            this.totalNotAnswered = notAttemptq;*/
            this.totalAnswered = answerdq;
            this.totalSubmited = submitedq + answerdq;
            this.totalVisited = visitedq;
            this.totalNotAnswered = notAttemptq + visitedq;
            this.pieChartData = [this.totalSubmited, this.totalNotAnswered];            
            this.isDone = true;
            document.getElementById('question-area').style.display = 'none';
            document.getElementById('submited-area').style.display = 'block';
        }
    }

    public backFromFinalSubmit() {
        //console.log(this.visitedQuesObj);
        //console.log(this.index);
        //console.log(this.totalQuestion);
        let indexDb = this.visitedQuesObj;

        /*        for (var i = this.index; i <= this.totalQuestion; i--) {
                    if(indexDb[i] != 'undefined' && indexDb[i] != 'submited')
                       this.currentIndex = i;
                }*/
        if ((this.index == this.totalQuestion) && (indexDb[this.index] != 'submited')) {
            // nothing
        }
        else {
            for (var i = this.index; i > 0; --i) {
                //console.log('loop index '+indexDb[i]);
                if (indexDb[i] == 'visited') {
                    this.index = i;
                    break;
                }

            }
        }
        this.getVivaQuestionByIndex();
        //console.log(this.index);       
        document.getElementById('question-area').style.display = 'block';
        document.getElementById('submited-area').style.display = 'none';
        document.getElementById('exit-test').style.display = 'block';
    }

    // public submitExam(){
    //     if(this.settings['mandatory_exam'] == 1)
    //     {
    //         this.mandatorySwal.show();
    //     }
    //     else{
    //         this.setVivaSubmitted();
    //     }
    // }
    public submitExam() {
        if (this.settings['mandatory_exam'] == 1 && this.totalNotAnswered == 0 && this.totalVisited == 0) {
            this.setVivaSubmitted();
        }
        else if (this.settings['mandatory_exam'] == 0) {
            this.setVivaSubmitted();
        } else {
            this.mandatorySwal.show();
        }
    }

    public gotoHome() {
        this.router.navigateByUrl('/login');
    }
    /* Exit from exam and display chart*/
    public existExam() {
        this.openSubmitArea();
    }

    /* Final Viva Submitted */
    public setVivaSubmitted() {
        this.loading = true;
        this.spinner.show();
        this.examService.setVivaSubmit(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 2)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        document.getElementById('thanks-area').style.display = 'block';
                        document.getElementById('submited-area').style.display = 'none';
                        document.getElementById('exit-test').style.display = 'none';
                    }
                    else {
                        this.loading = false;
                        this.spinner.hide();
                        //this.router.navigateByUrl('/login');

                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }
    // events
    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    } 
    display ='none'; //default         
    freezetext: string = '';
    vivaStausFreeze() {
            this.examService.examFreezeStatus(this.globals.root_url, this.userData['id'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                        if (Number(data.freeze) == 1) {
                            this.isPause = true;
                            this.freezestatus = data.freeze;
                            this.freezetext = data.status; console.log(this.freezetext);
                            this.display='block';
                        }
                        else if (Number(data.freeze) == 0) {
                            this.isPause = false;
                            //console.log('call==>', data.freeze)
                            this.display='none';
                        }

                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    } 
    secLanguages: any;
    primary_lang_name: string;
    primary_lang_code: string;      
    getSecondaryLang() {
            this.examService.getSecLanguages(this.globals.root_url, this.settings['module'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                      this.secLanguages = data.languages;
                      this.primary_lang_name = data.primary_lang_name;
                      this.primary_lang_code = data.primary_lang_code;
                      this.currentlanguage = data.primary_lang_code;
                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    }           
}
